import React, { Component } from 'react'
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1'
import Hint from '~/Common-Objects/UI/Hint/Hint'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import axios from '~/data/http/axios'
import i18n from '~/i18n'

//type 2 and type 3 merge tags
//apply to campaign sends only
//for example campaignName, campaignSubject
//type 2 is subscriber level (sub email, etc)
//type 3 is campaign level (campaign name, subject, etc)

class CampaignMergeTags extends Component {
    constructor(props) {
        super(props)
        this.state = {
            mergeTags: [],
            filter: '',
            search: '',
            loaded: false
        }
    }

    componentDidMount() {
        this.getMergeTags()
    }
    getMergeTags() {
        var types = []
        if (this.props.includeSubscriber) types.push('2')
        if (this.props.hasWorkflowEmails) types.push('3')
        if (this.props.includeSubCustomFields) types.push('4')
        if (this.props.includeRss) types.push('5')
        if (this.props.includeSystem) types.push('1')
        let q = '?type=' + types.join(',')
        if (this.props.AutomationId) q += '&AutomationId=' + this.props.AutomationId

        axios.get('/mergeTags' + q).then((results) => {
            var mergeTags = results.data.MergeTags
            mergeTags.forEach((tag) => {
                if (!tag.fieldType) {
                    var tmpTag = tag.tag.replace(/\{/g, '').replace(/\}/g, '')
                    var newDesc = i18n.t('mergeTags.' + tmpTag)
                    if (newDesc) {
                        tag.description = newDesc
                    }
                }
            })

            this.setState({
                mergeTags: mergeTags,
                loaded: true
            })
        })
    }

    render() {
        if (!this.state.loaded) return <LoadingIcons iconType='2' />
        let others = {}
        let otherTypes = []
        let apps = {}
        let appTypes = []

        let mergeTags = this.state.mergeTags.slice()
        if (this.state.search) {
            mergeTags = mergeTags.filter(
                (m) =>
                    (m.tag || '').toLowerCase().indexOf(this.state.search.toLowerCase()) > -1 ||
                    (m.description || '').toLowerCase().indexOf(this.state.search.toLowerCase()) > -1
            )
        }

        mergeTags.forEach((t) => {
            if (t.type && !parseInt(t.type)) {
                if (!others[t.type]) {
                    others[t.type] = []
                    otherTypes.push(t.type)
                }
                others[t.type].push(t)
            }
            if (t.subType) {
                if (!apps[t.subType]) {
                    apps[t.subType] = []
                    appTypes.push(t.subType)
                }
                apps[t.subType].push(t)
            }
        })

        let systemTags = mergeTags.filter((theFilt) => theFilt.type == 1)
        let customTags = mergeTags.filter((theFilt) => theFilt.type == 2 && !theFilt.subType)
        let campaignTags = mergeTags.filter((theFilt) => theFilt.type == 3 && !theFilt.subType)
        let rssTags = mergeTags.filter((theFilt) => theFilt.type == 5 && !theFilt.subType)

        let groups = []
        if (systemTags.length) {
            groups.push({
                name: i18n.t('templates:mergetags.system'),
                type: '1',
                tags: systemTags
            })
        }
        if (rssTags.length) {
            groups.push({
                name: 'RSS Tags',
                type: '5',
                tags: rssTags
            })
        }
        if (customTags.length) {
            groups.push({
                name: i18n.t('templates:mergetags.custom'),
                type: '2',
                tags: customTags
            })
        }
        if (campaignTags.length) {
            groups.push({
                name: 'Campaign',
                type: '3',
                tags: campaignTags
            })
        }

        let filterOptions = [{ label: i18n.t('all'), value: '' }]

        if (!!systemTags.length) filterOptions.push({ value: '1', label: i18n.t('templates:mergetags.system') })
        if (!!rssTags.length) filterOptions.push({ value: '5', label: 'RSS Tags' })
        if (!!customTags.length) filterOptions.push({ value: '2', label: i18n.t('templates:mergetags.custom') })
        if (!!campaignTags.length) filterOptions.push({ value: '3', label: 'Campaign' })
        appTypes.forEach((t) => {
            filterOptions.push({ value: t, label: t })
        })
        otherTypes.forEach((t) => {
            filterOptions.push({ value: t, label: t })
        })

        return (
            <div className={this.props.minimal ? 'mergeTags-minimal' : ''}>
                {!this.props.inDrawer && (
                    <div className='quickFlex mar-b25'>
                        <Hint
                            className='mar-0'
                            iconLeft={<Icons icon='arrowLeft' />}
                            onClick={this.props.close}
                        >
                            {i18n.t('subscribers:subscriber.back')}
                        </Hint>
                    </div>
                )}
                {!this.props.minimal && <h4 className='mar-b25'>Merge Tags</h4>}
                {!this.props.minimal && (
                    <div className='mar-b25'>Please select from the following merge tags to insert.</div>
                )}
                <div className='mergeTags-header-options'>
                    <TextInput
                        label={!this.props.minimal && 'Search'}
                        value={this.state.search}
                        onChange={(e) => this.setState({ search: e.currentTarget.value })}
                        outerClassName={this.props.minimal ? 'mar-b10' : 'mar-b25'}
                        placeholder='Search for Name or Merge Tag'
                    />
                    <Select
                        label={!this.props.minimal && i18n.t('filter')}
                        value={this.state.filter}
                        onChange={(e) => this.setState({ filter: e.currentTarget.value })}
                        data={filterOptions}
                        outerClassName={!this.props.minimal && 'mar-b25'}
                    />
                </div>

                {(!this.state.filter || this.state.filter === '1') && !!systemTags.length && (
                    <Paper>
                        {!this.state.filter && <h4 className='mar-b15'>{i18n.t('templates:mergetags.system')}</h4>}
                        <DataTable1
                            noResultsTxt={''}
                            tableData={systemTags.map((theTag) => {
                                return [
                                    {
                                        headerValue: ' ',
                                        width: '50%',
                                        value: (
                                            <a
                                                style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}
                                                onClick={() => {
                                                    this.props.insertMergeTag(theTag.tag, this.props.fieldName)
                                                }}
                                            >
                                                {theTag.tag}
                                            </a>
                                        )
                                    },
                                    {
                                        headerValue: ' ',
                                        width: '50%',
                                        value: (
                                            <div
                                                style={{
                                                    cursor: 'pointer',
                                                    wordBreak: 'break-word',
                                                    whiteSpace: 'normal'
                                                }}
                                                onClick={() => {
                                                    this.props.insertMergeTag(theTag.tag, this.props.fieldName)
                                                }}
                                            >
                                                {theTag.description}
                                            </div>
                                        )
                                    }
                                ]
                            })}
                            loadingData={false}
                            dataUpdater={() => {}}
                            width='100%'
                            hasCheckBoxes='no'
                        />
                    </Paper>
                )}
                {(!this.state.filter || this.state.filter === '5') && !!rssTags.length && (
                    <Paper>
                        {!this.state.filter && <h4 className='mar-b15'>RSS Tags</h4>}
                        <DataTable1
                            noResultsTxt={''}
                            tableData={rssTags.map((theTag) => {
                                return [
                                    {
                                        headerValue: ' ',
                                        width: '50%',
                                        value: (
                                            <a
                                                style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}
                                                onClick={() => {
                                                    this.props.insertMergeTag(theTag.tag, this.props.fieldName)
                                                }}
                                            >
                                                {theTag.description}
                                            </a>
                                        )
                                    },
                                    {
                                        headerValue: ' ',
                                        width: '50%',
                                        value: (
                                            <div
                                                style={{
                                                    cursor: 'pointer',
                                                    fontWeight: 'initial',
                                                    wordBreak: 'break-word',
                                                    whiteSpace: 'normal'
                                                }}
                                                onClick={() => {
                                                    this.props.insertMergeTag(theTag.tag, this.props.fieldName)
                                                }}
                                            >
                                                {theTag.tag}
                                            </div>
                                        )
                                    }
                                ]
                            })}
                            loadingData={false}
                            dataUpdater={() => {}}
                            width='100%'
                            hasCheckBoxes='no'
                        />
                    </Paper>
                )}

                {(!this.state.filter || this.state.filter === '2') && !!customTags.length && (
                    <Paper>
                        {!this.state.filter && <h4 className='mar-b15'>{i18n.t('templates:mergetags.custom')}</h4>}
                        <DataTable1
                            noResultsTxt={''}
                            tableData={customTags.map((theTag) => {
                                return [
                                    {
                                        headerValue: ' ',
                                        width: '50%',
                                        value: (
                                            <a
                                                style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}
                                                onClick={() => {
                                                    this.props.insertMergeTag(theTag.tag, this.props.fieldName)
                                                }}
                                            >
                                                {theTag.description}
                                            </a>
                                        )
                                    },
                                    {
                                        headerValue: ' ',
                                        width: '50%',
                                        value: (
                                            <div
                                                style={{
                                                    cursor: 'pointer',
                                                    fontWeight: 'initial',
                                                    wordBreak: 'break-word',
                                                    whiteSpace: 'normal'
                                                }}
                                                onClick={() => {
                                                    this.props.insertMergeTag(theTag.tag, this.props.fieldName)
                                                }}
                                            >
                                                {theTag.tag}
                                            </div>
                                        )
                                    }
                                ]
                            })}
                            loadingData={false}
                            dataUpdater={() => {}}
                            width='100%'
                            hasCheckBoxes='no'
                        />
                    </Paper>
                )}

                {(!this.state.filter || this.state.filter === '3') && !!campaignTags.length && (
                    <Paper>
                        {!this.state.filter && <h4 className='mar-b15'>Campaign</h4>}
                        <DataTable1
                            noResultsTxt={''}
                            tableData={campaignTags.map((theTag) => {
                                return [
                                    {
                                        headerValue: ' ',
                                        width: '50%',
                                        value: (
                                            <a
                                                style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}
                                                onClick={() => {
                                                    this.props.insertMergeTag(theTag.tag, this.props.fieldName)
                                                }}
                                            >
                                                {theTag.description}
                                            </a>
                                        )
                                    },
                                    {
                                        headerValue: ' ',
                                        width: '50%',
                                        value: (
                                            <div
                                                style={{
                                                    cursor: 'pointer',
                                                    fontWeight: 'initial',
                                                    wordBreak: 'break-word',
                                                    whiteSpace: 'normal'
                                                }}
                                                onClick={() => {
                                                    this.props.insertMergeTag(theTag.tag, this.props.fieldName)
                                                }}
                                            >
                                                {theTag.tag}
                                            </div>
                                        )
                                    }
                                ]
                            })}
                            loadingData={false}
                            dataUpdater={() => {}}
                            width='100%'
                            hasCheckBoxes='no'
                        />
                    </Paper>
                )}

                {appTypes.map((prop) => {
                    if (this.state.filter && this.state.filter != prop) return ''
                    return (
                        <Paper key={prop}>
                            {!this.state.filter && <h4 className='mar-b15'>{prop}</h4>}
                            <DataTable1
                                noResultsTxt={''}
                                tableData={apps[prop].map((theTag) => {
                                    return [
                                        {
                                            headerValue: ' ',
                                            width: '50%',
                                            value: (
                                                <a
                                                    style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}
                                                    onClick={() => {
                                                        this.props.insertMergeTag(theTag.tag, this.props.fieldName)
                                                    }}
                                                >
                                                    {theTag.description}
                                                </a>
                                            )
                                        },
                                        {
                                            headerValue: ' ',
                                            width: '50%',
                                            value: (
                                                <div
                                                    style={{
                                                        cursor: 'pointer',
                                                        fontWeight: 'initial',
                                                        wordBreak: 'break-word',
                                                        whiteSpace: 'normal'
                                                    }}
                                                    onClick={() => {
                                                        this.props.insertMergeTag(theTag.tag, this.props.fieldName)
                                                    }}
                                                >
                                                    {theTag.tag}
                                                </div>
                                            )
                                        }
                                    ]
                                })}
                                loadingData={false}
                                dataUpdater={() => {}}
                                width='100%'
                                hasCheckBoxes='no'
                            />
                        </Paper>
                    )
                })}

                {otherTypes.map((prop) => {
                    if (this.state.filter && this.state.filter != prop) return ''
                    return (
                        <Paper key={prop}>
                            {!this.state.filter && <h4 className='mar-b15'>{prop}</h4>}
                            <DataTable1
                                noResultsTxt={''}
                                tableData={others[prop].map((theTag) => {
                                    return [
                                        {
                                            headerValue: ' ',
                                            width: '50%',
                                            value: (
                                                <a
                                                    style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}
                                                    onClick={() => {
                                                        this.props.insertMergeTag(theTag.tag, this.props.fieldName)
                                                    }}
                                                >
                                                    {theTag.description}
                                                </a>
                                            )
                                        },
                                        {
                                            headerValue: ' ',
                                            width: '50%',
                                            value: (
                                                <a
                                                    style={{
                                                        cursor: 'pointer',
                                                        fontWeight: 'initial',
                                                        wordBreak: 'break-word',
                                                        whiteSpace: 'normal'
                                                    }}
                                                    onClick={() => {
                                                        this.props.insertMergeTag(theTag.tag, this.props.fieldName)
                                                    }}
                                                >
                                                    {theTag.tag}
                                                </a>
                                            )
                                        }
                                    ]
                                })}
                                loadingData={false}
                                dataUpdater={() => {}}
                                width='100%'
                                hasCheckBoxes='no'
                            />
                        </Paper>
                    )
                })}
            </div>
        )
    }
}

export default CampaignMergeTags
